module.exports = __webpack_public_path__ + "static/Cafe24Danjunghae.subset-d5d239c40f157ae6491c1c542a6802c4.woff2";